import { useQuery } from "react-query";
import { apiService } from "../services/api";

export interface FeatureRequestTeam {
  id: string;
  name: string;
  slug: string;
  createdByEmail: string;
  createdAt: string;
  members: string[] | null;
  topics: string[] | null;
  canEdit: boolean;
}

export function useFeatureRequestTeams() {
  const query = useQuery<FeatureRequestTeam[]>(
    "feature-request-teams",
    async () => {
      const res = await apiService.getFeatureRequestTeams();
      return (res.data?.data?.items ?? []) as FeatureRequestTeam[];
    },
    { staleTime: 60_000 },
  );

  return { ...query, teams: query.data ?? [] };
}
